import React from 'react';
export function MechanismSection() {
  return <section id="como-funciona" className="py-6 md:py-9 px-5 bg-[radial-gradient(ellipse_at_bottom_left,rgba(0,102,255,0.15)_0%,transparent_60%),linear-gradient(180deg,var(--dark-bg),var(--card-bg))]" data-id="element-85">
      <div className="max-w-[900px] mx-auto" data-id="element-86">
        <span className="inline-block font-heading font-bold text-[0.75rem] tracking-[3px] uppercase text-magenta-bright mb-2" data-id="element-87">
          El mecanismo
        </span>

        <h2 className="text-[clamp(1.6rem,4vw,2.5rem)] font-heading font-black leading-[1.15] mb-3" data-id="element-88">
          Así funciona el
          <br data-id="element-89" />
          <span className="text-gradient-blue" data-id="element-90">Ciclo P-C-V</span> —<br data-id="element-91" />y cómo
          se interrumpe
        </h2>

        <div className="flex flex-col md:flex-row items-center justify-center gap-0 my-4 flex-wrap" data-id="element-92">
          {/* Node 1: Placer */}
          <div className="text-center py-4 px-4 rounded-2xl flex-1 min-w-[140px] max-w-[200px] bg-gradient-to-br from-[rgba(255,165,0,0.2)] to-[rgba(255,215,0,0.1)] border-2 border-[rgba(255,165,0,0.5)]" data-id="element-93">
            <div className="text-[2.5rem] mb-[10px]" data-id="element-94">✨</div>
            <div className="font-heading font-black text-[1.3rem] mb-2 text-gold" data-id="element-95">
              PLACER
            </div>
            <div className="text-[0.85rem] text-white/65 leading-[1.5]" data-id="element-96">
              El cerebro busca aliviar el vacío con una recompensa inmediata
            </div>
          </div>

          <div className="text-[2rem] text-white/25 py-[5px] md:px-[10px] shrink-0 rotate-90 md:rotate-0" data-id="element-97">
            →
          </div>

          {/* Node 2: Culpa */}
          <div className="text-center py-4 px-4 rounded-2xl flex-1 min-w-[140px] max-w-[200px] bg-gradient-to-br from-[rgba(194,0,111,0.2)] to-[rgba(107,0,182,0.1)] border-2 border-[rgba(194,0,111,0.5)]" data-id="element-98">
            <div className="text-[2.5rem] mb-[10px]" data-id="element-99">⚡</div>
            <div className="font-heading font-black text-[1.3rem] mb-2 text-magenta-bright" data-id="element-100">
              CULPA
            </div>
            <div className="text-[0.85rem] text-white/65 leading-[1.5]" data-id="element-101">
              La vergüenza no sana — vacía más. Y un vacío más profundo necesita
              más placer
            </div>
          </div>

          <div className="text-[2rem] text-white/25 py-[5px] md:px-[10px] shrink-0 rotate-90 md:rotate-0" data-id="element-102">
            →
          </div>

          {/* Node 3: Vacío */}
          <div className="text-center py-4 px-4 rounded-2xl flex-1 min-w-[140px] max-w-[200px] bg-gradient-to-br from-[rgba(0,102,255,0.2)] to-[rgba(0,207,255,0.1)] border-2 border-[rgba(0,102,255,0.5)]" data-id="element-103">
            <div className="text-[2.5rem] mb-[10px]" data-id="element-104">🌀</div>
            <div className="font-heading font-black text-[1.3rem] mb-2 text-blue-light" data-id="element-105">
              VACÍO
            </div>
            <div className="text-[0.85rem] text-white/65 leading-[1.5]" data-id="element-106">
              La tensión interna sin resolver alimenta el siguiente impulso
            </div>
          </div>

          <div className="text-[2rem] text-white/25 py-[5px] md:px-[10px] shrink-0 rotate-90 md:rotate-0" data-id="element-107">
            ↩
          </div>
        </div>

        <div className="bg-gradient-to-br from-[rgba(107,0,182,0.25)] to-[rgba(194,0,111,0.15)] border border-[rgba(107,0,182,0.5)] rounded-2xl p-5 mt-3" data-id="element-108">
          <h3 className="text-[1.25rem] font-heading font-bold text-gold mb-2" data-id="element-109">
            🔑 La razón real por la que no puedes parar
          </h3>
          <div className="text-[1rem] leading-[1.6] text-white/85 space-y-2" data-id="element-110">
            <p data-id="element-111">
              Tu cerebro no busca el placer porque seas débil. Lo busca porque
              en algún punto aprendió que el placer{' '}
              <strong data-id="element-112">tapa el vacío.</strong> Una tensión interna sin nombre,
              que la conducta interrumpe temporalmente.
            </p>
            <p data-id="element-113">
              El problema es lo que viene después: la culpa. La culpa no te sana
              — <strong data-id="element-114">te vacía más.</strong> Genera una versión más profunda
              del vacío original. Y un vacío más profundo necesita más placer
              para taparlo.
            </p>
            <p className="text-gold font-bold" data-id="element-115">
              PLACER, CULPA Y VACÍO interrumpe ese bucle desde adentro — con
              prácticas diarias específicas para cada punto del ciclo.
            </p>
          </div>
        </div>
      </div>
    </section>;
}